import { render, staticRenderFns } from "./Tv.vue?vue&type=template&id=f2d5ff66&"
var script = {}
import style0 from "./Tv.vue?vue&type=style&index=0&id=f2d5ff66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports